module.exports = __webpack_public_path__ + "static/media/lobby-card-gallery.df26ea62.svg";